import get from "lodash/get";
import { createSelector } from "reselect";
import { NAMESPACE } from "../constants";
export const getAccessLevelsKey = createSelector((state) => get(state, `[${NAMESPACE}].accessLevelsKey`), (accessLevelsKey) => accessLevelsKey);
export const getAccessLevelNew = createSelector((state) => get(state, `[${NAMESPACE}].accessLevelNew`), (accessLevelNew) => accessLevelNew);
